import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[has-permission]',
})
export class HasPermissionDirective implements OnInit {
  @Input() permission: string[];

  constructor(private eltRef: ElementRef, private authenticationService: AuthenticationService) {}

  ngOnInit() {
    const hasPermission = this.authenticationService.hasPermission(this.permission);
    if (!hasPermission) {
      const el: HTMLElement = this.eltRef.nativeElement;
      if (el.parentNode != null) {
        el.parentNode.removeChild(el);
      }
    }
  }
}
